module.exports = __webpack_public_path__ + "img/bg_stage.9534f126.png";